import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    let token = sessionStorage.getItem('token');

    if (!token) {
      const lsToken = localStorage.getItem('hrms_token');
      if (lsToken) {
        const lsUser           = localStorage.getItem('hrms_user');
        const lsMustChangePw   = localStorage.getItem('hrms_mustChangePw') || 'false';
        sessionStorage.setItem('token', lsToken);
        if (lsUser) sessionStorage.setItem('user', lsUser);
        sessionStorage.setItem('mustChangePassword', lsMustChangePw);
        token = lsToken;
      }
    }

    if (!token) {
      const safeToSave = state.url && !this.isAdminOnlyUrl(state.url);
      if (safeToSave) sessionStorage.setItem('redirect_url', state.url);
      else sessionStorage.removeItem('redirect_url');
      return this.router.parseUrl('/login');
    }

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      if (payload.exp && payload.exp * 1000 < Date.now()) {
        sessionStorage.removeItem('token');
        sessionStorage.removeItem('user');
        localStorage.removeItem('hrms_token');
        localStorage.removeItem('hrms_user');
        sessionStorage.setItem('redirect_url', state.url);
        return this.router.parseUrl('/login');
      }
    } catch {
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('user');
      return this.router.parseUrl('/login');
    }

    if (sessionStorage.getItem('mustChangePassword') === 'true') {
      return this.router.parseUrl('/login');
    }

    return true;
  }

  private isAdminOnlyUrl(url: string): boolean {
    const adminPrefixes = ['/settings', '/employees', '/departments', '/payroll',
      '/admin', '/clients', '/reports', '/role-management', '/shifts',
      '/onboarding', '/offboarding', '/assets', '/geo-zones', '/email-templates',
      '/people', '/org-chart'];
    return adminPrefixes.some(p => url === p || url.startsWith(p + '/') || url.startsWith(p + '?'));
  }
}
